import type { ComponentType, ReactNode } from "react";
import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
	icon?: ComponentType<{ className?: string }>;
	title: ReactNode;
	description?: ReactNode;
	action?: ReactNode;
	className?: string;
}

/** Centered icon + message used by empty tables and panels ("No orders"). */
export function EmptyState({ icon: Icon = Inbox, title, description, action, className }: EmptyStateProps) {
	return (
		<div className={cn("flex flex-col items-center justify-center gap-2 px-6 py-10 text-center", className)}>
			<Icon className="size-8 text-muted/60" />
			<div className="text-sm font-medium">{title}</div>
			{description && <div className="max-w-sm text-xs text-muted">{description}</div>}
			{action && <div className="mt-2">{action}</div>}
		</div>
	);
}
